<template>
    <project ref="project"
        classContainer="dick-container dick-1" 
        classOverlay="overlay-dick"
        :bubbleOneData="this.bubbleOneData"
        :bubbleTwoData="this.bubbleTwoData"
        :previewOneData="this.previewOneData"
        :previewSliderOneData="this.previewSliderOneData"
        :previewSliderTwoData="this.previewSliderTwoData"/>
    
    <!--<img class="example" src="@/assets/dick/home1.jpg" />-->    
    
</template>

<script>
    import Project from '../../Project.vue'
    
    export default {
        components: {
            Project 
        }, 
        name: "dickOne",
        data: () => ({
            bubbleOneData: {
                class:"bubble-one-dick-1",
                text: "<p>"+
                            "While at gsi I worked with Dick’s to<br/>"+ 
                            "redesign their site which was a lightly<br/>"+
                            "themed, templated experience that<br/>" + 
                            "didn’t reflect the brand’s depth and<br/>"+
                            "authenticity."+
                        "</p><br/>"+
                        "<p>"+
                            "This was a massive effort that<br/>"+
                            "involved hiring a design team and<br/>"+
                            "orchestrating a series of photoshoots."+
                        "</p>",
                title:"Branding & Redesign",
                fontSizeInnerText:"0.79rem",
                marginLeft:"-2.4rem",
                fontSize:"2rem", 
                marginTop:"4%",
                color:"#08483d",
                colorOverlay:"#fff",
                colorText:"#08483d",
                textSlice:5
            },
            bubbleTwoData:{
                class: "bubble-two-dick-1",
                text:   "<p>BRANDING</p><br/>"+
                        "<p>CREATIVE DIRECTION</p><br/>"+
                        "<p>CASTING & PHOTOSHOOT ART DIRECTION</p><br/>"+
                        "<p>DIGITAL & UI DESIGN</p>",
                color:"#08483d",
                colorOverlay:"#12a58d",
                colorText:"#fff"
            },
            previewOneData:{
                class:"dick-1-preview",
                img:"assets/dick/dick_slide_1.jpg",
                upDown:false,
                forward:true,
                isBrik: false
            },
            previewSliderOneData:{
                class: "dick-1-video-1",
                images:['assets/dick/dick1/1_Dicks_Screen_L_1_L.jpg', 'assets/dick/dick1/1_Dicks_Screen_L_2_L.jpg', 'assets/dick/dick1/1_Dicks_Screen_L_3_L.jpg']
            },
            previewSliderTwoData:{
                class: "dick-1-video-2",
                images:['assets/dick/dick1/1_Dicks_Screen_1_R.jpg', 'assets/dick/dick1/1_Dicks_Screen_2_R.jpg', 'assets/dick/dick1/1_Dicks_Screen_3_R.jpg']
            },
        }),
        methods: {
            openNonAnimated(){
                this.$refs.project.openNonAnimated()
            },
            open(onOpened){
                this.$refs.project.open(onOpened)
            },
            close(){
                this.$refs.project.close()
            },
            pause(){
                this.$refs.project.pause()
            },
            play(){
                this.$refs.project.play()
            },
            isHovering(){
                return this.$refs.project.isHovering
            }
        },
    }
</script>

<style>
    .dick-1-preview{
        width: 38vw;
        height: 29.5vw;
        top: 19%;
        left: 33%;
    }

    .dick-1-video-2{
        top: 54.5% !important;
        left: 65% !important;
        width: 18.5vw !important;
        height: 11.5vw !important;
    }

    .dick-1-video-1{
        top: 26% !important;
        left: 15.5% !important;
        width: 17.5vw !important;
        height: 11vw !important;
    }

    .bubble-two-dick-1{
        left: 69%;
        top: 69.5%;
        height: 13vw;
        width: 13vw;
    }

    .bubble-one-dick-1{
        left: 32.5%;
        top: 58.75%;
        height: 17.5vw;
        width: 17.5vw;
    }
    
    .dick-container{
        height: 100%;
        width: 100%;
        background-repeat: no-repeat;
        background-size: cover;
        position: absolute;
        top: 0;
        left: 0;
    }

    @media (orientation: portrait) {
        .bubble-one-dick-1 {
            top: 60.75%;
            height: 57vw;
            width: 57vw;
        }
        .bubble-two-dick-1{
            top: 20.5%;
            left: 55%;
            height: 42.5vw;
            width: 42.5vw;
        }

        .dick-1-preview{
            width: 57vw;
            height: 44.25vw;
            top: 37%;
            left: 21%;
        }

        .dick-1-video-2{
            top: 54.5% !important;
            left: 65% !important;
            width: 27.75vw !important;
            height: 16.5vw !important;
        }

        .dick-1-video-1{
            top: 36% !important;
            left: 7.5% !important;
            width: 26.25vw !important;
            height: 16.5vw !important;
        }
    }

</style>